import { Divider } from '@mui/material'
import React, { useContext } from 'react'
import { TiposServicioContext } from '../../pages/catalogos/ServiciosTipoPage'
import { TipoServicioComponent } from './TipoServicioComponent'

export const TablaTiposServicio = ({tiposServicio}) => {
  const {modalAgregaTipoServicio, setModalAgregaTipoServicio} = useContext(TiposServicioContext)

  return (
    <div
        style={{
            display:'column',
            maxWidth:700,
            marginTop:20,
            maxHeight:'60%',
            overflowY:'auto'
        }}
    >
      <div
        style={{
          display:'flex',
          flexDirection:'row'
        }}
      >
        <div
          style={{
            fontSize:14,
            fontWeight:'bold'
          }}
        >
          Tipo de Servicio 
        </div>
      </div>
      <Divider />
      {
        tiposServicio?.map(tipoServicio => (
          <TipoServicioComponent tipoServicio={tipoServicio} />
        ))
      }
    </div>
  )
}
